/**
 * @generated SignedSource<<7679bb5ea4de4da92cd5764a0f7a4b9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineStoreCustomizeSectionsSectionQuery$variables = {
  routineId: string;
  storeId?: string | null;
};
export type RoutineStoreCustomizeSectionsSectionQuery$data = {
  readonly routine: {
    readonly activeTaskList: {
      readonly sections: ReadonlyArray<{
        readonly canBeDisabled: boolean;
        readonly id: string;
        readonly isDisabled: boolean;
        readonly tasks: ReadonlyArray<{
          readonly canBeDisabled: boolean;
          readonly id: string;
          readonly isDisabled: boolean;
          readonly taskId: string;
          readonly " $fragmentSpreads": FragmentRefs<"RoutineStoreCustomizeSectionsSection_task">;
        }>;
        readonly title: string | null;
      }>;
    } | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenRoutineDescription_Routine">;
  } | null;
};
export type RoutineStoreCustomizeSectionsSectionQuery = {
  response: RoutineStoreCustomizeSectionsSectionQuery$data;
  variables: RoutineStoreCustomizeSectionsSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDisabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeDisabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineStoreCustomizeSectionsSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineOccasionScreenRoutineDescription_Routine"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "RoutineTaskList",
            "kind": "LinkedField",
            "name": "activeTaskList",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineTaskListSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineTaskListSectionTask",
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RoutineStoreCustomizeSectionsSection_task"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineStoreCustomizeSectionsSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "RoutineTaskList",
            "kind": "LinkedField",
            "name": "activeTaskList",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineTaskListSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineTaskListSectionTask",
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v6/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d74b89f71e2d45ffd1aa2565b5f86d11",
    "id": null,
    "metadata": {},
    "name": "RoutineStoreCustomizeSectionsSectionQuery",
    "operationKind": "query",
    "text": "query RoutineStoreCustomizeSectionsSectionQuery(\n  $routineId: ID!\n  $storeId: ID\n) {\n  routine(id: $routineId) {\n    id\n    ...RoutineOccasionScreenRoutineDescription_Routine\n    activeTaskList(storeId: $storeId) {\n      sections {\n        id\n        isDisabled\n        canBeDisabled\n        title\n        tasks {\n          id\n          taskId\n          isDisabled\n          canBeDisabled\n          ...RoutineStoreCustomizeSectionsSection_task\n        }\n      }\n    }\n  }\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment RoutineStoreCustomizeSectionsSection_task on RoutineTaskListSectionTask {\n  task {\n    __typename\n    title\n    id\n  }\n  canBeDisabled\n}\n"
  }
};
})();

(node as any).hash = "46e8a92cba5ba6f78d8663e3c593bbb4";

export default node;
